import React from 'react';
import './PremiumContentPriceTag.scss';
import {
  getPremiumContentPrice,
  getUniquePremiumContent
} from '../../../utilities/HelperFunctions/HelperFunctions';
import * as Constants from '../../../utilities/constants/Constants';
import { connect } from 'react-redux';
import { string } from '../../../localization';
import { getPlacings } from '../../../redux/ProjectData/Project';

class PremiumContentPriceTag extends React.PureComponent {
  render() {
    const { storeData, project } = this.props;
    const currencyPlacement = storeData ? storeData.placeMsrpCurrency : null;
    const classForCurrencyPlacement =
      currencyPlacement === Constants.BEFORE_PRICE_KEY
        ? ' currency-before-price'
        : ' currency-after-price';

    const placings =
      project && getPlacings(project) ? getPlacings(project) : null;
    const list = placings ? getUniquePremiumContent(placings) : null;
    const price = list
      ? getPremiumContentPrice(
          list,
          storeData.conversionUnitEur,
          storeData.conversionUnitUsd
        )
      : null;
    return (
      <>
        {price !== 0 ? (
          <div className='premium-content-price-tag'>
            <div className='border-right border-right-transform' />
            <div className='arrow-left' />
            <div className='border-right border-right-transform-lower' />

            <div className='price-container'>
              {string.PREMIUM_IMAGES_TITLE_KEY}
              <br />
              <span className={`price${classForCurrencyPlacement}`}>
                {' '}
                <span>{price ? price.toFixed(2) : null}</span>
                <span className='pl-1 pr-1'>
                  {storeData ? storeData.msrpCurrency : null}
                </span>
              </span>
            </div>
            <div className='message'>{string.CUSTOM_PRICE_SIGN_IN_KEY}</div>
          </div>
        ) : null}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.home.language,
    envData: state.modal.envData,
    storeData: state.modal.storeData,
    activeObject: state.fabricCanvas.activeObject,
    triggerRedraw: state.sideBar.triggerRedraw,
    project: state.finalCheck.project
  };
}

export default connect(mapStateToProps)(PremiumContentPriceTag);
